import { useEffect, useState } from "react"
import { Container, Question, QuestionList, Search } from "../../components"
import styles from './styles.module.css'
import api from "../../api"
import { cssClear } from "../../utils/fn"

const Main = ({ setQuery}) => {
	cssClear()
	const [questions, setQuestions] = useState([])
	useEffect(_ => {
		setQuery('')
		getQuestions()
	}, [])

	const getQuestions = () => {
		api.getQuestions({})
			.then(res => {
				setQuestions(res.result)
			})
			.catch(err => console.error('Login error', err.toString()))
	}
	return (
		<Container className={styles.container}>
			<Search setQuery={setQuery}/>
			<QuestionList>
				{questions.map(item => <Question
					{...item}
					key={item._id}
				/>)}
			</QuestionList>
		</Container>
	)
}

export default Main